// class CartNotification extends HTMLElement {
//   constructor() {
//     super();

//     this.notification = document.getElementById('cart-notification');
//     this.header = document.querySelector('sticky-header');
//     this.onBodyClick = this.handleBodyClick.bind(this);

//     this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
//       closeButton.addEventListener('click', this.close.bind(this))
//     );
//   }

//   open() {
//     this.notification.classList.add('animate', 'active');

//     this.notification.addEventListener(
//       'transitionend',
//       () => {
//         this.notification.focus();
//         trapFocus(this.notification);
//       },
//       { once: true }
//     );

//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   close() {
//     this.notification.classList.remove('active');
//     document.body.removeEventListener('click', this.onBodyClick);

//     removeTrapFocus(this.activeElement);
//   }

//   renderContents(parsedState) {
//     this.cartItemKey = parsedState.key;
//     this.getSectionsToRender().forEach((section) => {
//       document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     if (this.header) this.header.reveal();
//     this.open();
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-notification-product',
//         selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
//       },
//       {
//         id: 'cart-notification-button',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   handleBodyClick(evt) {
//     const target = evt.target;
//     if (target !== this.notification && !target.closest('cart-notification')) {
//       const disclosure = target.closest('details-disclosure, header-menu');
//       this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
//       this.close();
//     }
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-notification', CartNotification);




class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return; // ✅ prevent crash

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        if (typeof trapFocus === 'function') {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);

      if (el && parsedState.sections[section.id]) {
        el.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}